import { Loader } from 'Core/Components';
import AppShell from 'ui/components/AppShell';
import { useAuth } from 'Utils/Hooks/useAuth';
import React, { lazy, Suspense } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
/** Admin Pages */
const OverviewPage = lazy(() => import('ui/pages/Overview'));
const AdminProductsPage = lazy(() => import('Views/Admin/Products'));
const AdminShortcodePage = lazy(() => import('Views/Admin/Shortcode'));
const AdminUserManagerPage = lazy(() => import('Views/Admin/UserManager'));
const AdminConfigurationPage = lazy(() => import('Views/Admin/Configuration'));
const AdminPartnerShortcodePage = lazy(() => import('Views/Admin/Partner'));
const AdminEmailReportPage = lazy(() => import('Views/Admin/EmailReport'));
const AdminReportPage = lazy(() => import('Views/Admin/Report'));
const AdminApiCheckerPage = lazy(() => import('Views/Admin/ApiChecker'));
const AdminPartnerCheckerPage = lazy(() => import('Views/Admin/PartnerChecker'));
const AdminUatTestRunsPage = lazy(() => import('Views/Admin/UatTestRuns'));
const AdminLogTracerPage = lazy(() => import('Views/Admin/LogTracer'));

/** Partner Pages */
const PartnerProductPage = lazy(() => import('Views/Partner/Products'));
const PartnerMessagePage = lazy(() => import('Views/Partner/Message'));
const PartnerReportPage = lazy(() => import('Views/Partner/Report'));
const PartnerNotificationPage = lazy(() => import('Views/Partner/Notification'));

const PrivateRoutes = () => {
  const { currentAdmin } = useAuth();
  
  // Function to check if the user type has access to a specific route
  const hasAccess = (routeUserType) => {
    return currentAdmin?.user_type === routeUserType;
  };
  
  return (
    <Routes>
      <Route element={<AppShell />}>
        {/* Redirect to Dashboard after success login/registartion */}
        {hasAccess('ADMIN') && (
          <>
            <Route path='auth/*' element={<Navigate to='/dashboard/home' />} />
            <Route path='dashboard' element={<Navigate to='/dashboard/home' />} />
            <Route
              path='dashboard/home'
              element={
                <SuspensedView>
                  <OverviewPage />
                </SuspensedView>
              }
            />
            <Route
              path='dashboard/product/*'
              element={
                <SuspensedView>
                  <AdminProductsPage />
                </SuspensedView>
              } 
            />
            <Route 
              path='dashboard/configuration/*' 
              element={
                <SuspensedView>
                  <AdminConfigurationPage />
                </SuspensedView>
              } 
            />
            <Route 
              path='dashboard/shortcode/*' 
              element={
                <SuspensedView>
                  <AdminShortcodePage />
                </SuspensedView>
              } 
            />
            <Route 
              path='dashboard/usermanager/*' 
              element={
                <SuspensedView>
                  <AdminUserManagerPage />
                </SuspensedView>
              } 
            />
            <Route 
              path='dashboard/partner-shortcode' 
              element={
                <SuspensedView>
                  <AdminPartnerShortcodePage />
                </SuspensedView>
              } 
            />
            <Route 
              path='dashboard/email-report' 
              element={
                <SuspensedView>
                  <AdminEmailReportPage />
                </SuspensedView>
              } 
            />
            <Route 
              path='dashboard/report/*' 
              element={
                <SuspensedView>
                  <AdminReportPage />
                </SuspensedView>
              } 
            />
            <Route
              path='dashboard/api-checker'
              element={
                <SuspensedView>
                  <AdminApiCheckerPage />
                </SuspensedView>
              }
            />
            <Route
              path='dashboard/partner-checker'
              element={
                <SuspensedView>
                  <AdminPartnerCheckerPage />
                </SuspensedView>
              }
            />
            <Route
              path='dashboard/uat-test-runs'
              element={
                <SuspensedView>
                  <AdminUatTestRunsPage />
                </SuspensedView>
              }
            />
            <Route
              path='dashboard/log-tracer'
              element={
                <SuspensedView>
                  <AdminLogTracerPage />
                </SuspensedView>
              }
            />
          </>
        )}

        {hasAccess('USER') && (
          <>
            {/** PARTNER START HERE **/}
            <Route path='auth/*' element={<Navigate to='/partner/home' />} />
            <Route path='partner' element={<Navigate to='/partner/home' />} />
            <Route
              path='partner/home'
              element={
                <SuspensedView>
                  <OverviewPage />
                </SuspensedView>
              }
            />
            <Route
              path='partner/product/*'
              element={
                <SuspensedView>
                  <PartnerProductPage />
                </SuspensedView>
              } 
            />
            <Route 
              path='partner/messages/send-message' 
              element={
                <SuspensedView>
                  <PartnerMessagePage />
                </SuspensedView>
              } 
            />
            <Route 
              path='partner/report/*' 
              element={
                <SuspensedView>
                  <PartnerReportPage />
                </SuspensedView>
              } 
            />
            <Route 
              path='partner/notification/*' 
              element={
                <SuspensedView>
                  <PartnerNotificationPage />
                </SuspensedView>
              } 
            />
          </>
        )}
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
};

const SuspensedView = ({children}) => {
  return <Suspense fallback={<Loader />}>{children}</Suspense>
}

export default PrivateRoutes;
